import { http, HttpResponse } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { type AccountsApiModel } from '../api-models/AccountsApiModel'
import { AccountsApiModelStub } from '../api-models/stubs/AccountsApiModel.stub'

export const mockGetRequestableAccountsByDepartment = (
  data: AccountsApiModel[] = AccountsApiModelStub.buildList(1),
  pagination = {},
  metadata = {}
) => {
  return http.get(
    '/api/v3/accounts/requestable/',
    () => {
      return HttpResponse.json(getResponseObject(data, pagination, metadata), {
        status: 200,
      })
    },
    { once: true }
  )
}
